// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditCategoryForm_DJ5RRoW4dHCrsyWTAw0D{width:500px}`, "",{"version":3,"sources":["webpack://./src/components/EditCategoryForm/EditCategoryForm.module.scss"],"names":[],"mappings":"AAAA,uCACE,WAAA","sourcesContent":[".EditCategoryForm {\n  width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EditCategoryForm": `EditCategoryForm_DJ5RRoW4dHCrsyWTAw0D`
};
export default ___CSS_LOADER_EXPORT___;
